import React, { useState, useContext, useEffect, useRef } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { createMuiTheme, Slide, Dialog, DialogContent, Toolbar, Typography, CssBaseline, IconButton, Grid, AppBar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { Checkbox } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import CancelIcon from '@material-ui/icons/Cancel';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import CloudDownloadRoundedIcon from '@material-ui/icons/CloudDownloadRounded';
import CloudUploadRoundedIcon from '@material-ui/icons/CloudUploadRounded';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { ConvertToCurrentTimeZone } from '../../header/timeFormatter';
import { HttpService } from "../../../apiAuthorization/httpService";
import { GlobalTheme } from '../../../layouts/theme';
import { Context } from "../../contexts/siteContext";
import { Theme } from '../../contexts/themeContext';
import Card from "../../card/card.js";
import CardHeader from "../../card/cardHeader.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Geography(props) {
    const classes = useStyles();
    const importFile = useRef(null);
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [locations, setLocations] = useState([]);
    const [site, setSite] = useState([]);
    const [action, setAction] = useState('');
    const [houseCode, setHouseCode] = useState('');
    const [siteName, setSiteName] = useState('');
    const [goLiveDate, setGoLiveDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [endDate, setEndDate] = useState('');
    const [coachSites, setCoachSites] = useState([]);
    const [currentCoachSite, setCurrentCoachSite] = useState([]);
    const [hrcSites, setHrcSites] = useState([]);
    const [currentHrcSite, setCurrentHrcSite] = useState([]);
    const [myDiningFacilitys, setMyDiningFacilitys] = useState([]);
    const [currentMyDiningFacility, setCurrentMyDiningFacility] = useState([]);
    const [useEpay, setUseEpay] = useState(false);
    const [active, setActive] = useState(true);
    const [truncate, setTruncate] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [showResults, setShowResults] = React.useState(false);
    const [siteOpen, setSiteOpen] = useState(false);
    const [deactivateSiteOpen, setDeactivateSiteOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [confirmMessage, setConfirmMessage] = React.useState('');   
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const BindButtons = () => (
        <span>
            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary }} startIcon={<EditRoundedIcon />} onClick={updateSiteOpen}>Update Site</Button>
            &nbsp; &nbsp;
            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary }} startIcon={<HighlightOffRoundedIcon />} onClick={dectivateOpen}>Deactivate Site</Button>
            &nbsp; &nbsp;
            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary }} startIcon={<CloudUploadRoundedIcon />} onClick={importConfirm}>Import from CSV</Button>
            &nbsp; &nbsp;
            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary }} startIcon={<CloudUploadRoundedIcon />} onClick={importTruncateConfirm}>Import from CSV (Truncate)</Button>
            &nbsp; &nbsp;
            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary }} startIcon={<CloudDownloadRoundedIcon />} onClick={exportToCSV}>Export to CSV</Button>
        </span>
    );

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const addSiteOpen = (e) => {
        setSiteOpen(true);
        setAction("Add");
        setSiteName("");
        setGoLiveDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    };

    const addSiteClose = () => {
        setSiteOpen(false);
        setActive(site.isActive);
    };

    const updateSiteOpen = () => {
        setSiteOpen(true);
        setAction("Update");
        setSiteName(site.name);
        if (site.startDate === null)
            setGoLiveDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
        else
            setGoLiveDate(site.startDate);
    };

    const dectivateOpen = () => {
        setDeactivateSiteOpen(true);
        setSiteName(site.name);
        if (site.endDate === null)
            setEndDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
        else
            setEndDate(site.endDate);
    };

    const deactivateSiteClose = () => {
        setDeactivateSiteOpen(false);
        setActive(site.isActive);
    };

    const changeStatus = (checked) => {
        setActive(checked);
        if (checked)
            updateSiteOpen();
        else
            dectivateOpen();
    };

    const bindData = (value) => {
        if (value === null) {
            setSite([]);
            setHouseCode("");
            setActive(false);
            setUseEpay(false);
            setCurrentCoachSite([]);
            setCurrentHrcSite([]);
            setCurrentMyDiningFacility([]);
            setShowResults(false);
        }
        else {
            setSite(value);
            setActive(value.isActive);
            getHouseCode(value);
            getCoachSites(value);
            getHrcSites(value);
            getMyDiningFacilitys(value);
            setShowResults(true);
        }
    };

    const getLocations = () => {
        setBackDrop(true);
        HttpService.post('/Geography/GetGeoLocations', {
        })
        .then((result) => {
            setLocations(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getHouseCode = (value) => {
        if (value.id > 0) {
            setBackDrop(true);
            HttpService.post('/Geography/GetHouseCode', {
                siteId: value.id
            })
            .then((result) => {
                if (result.data !== null) {
                    setHouseCode(result.data.HouseCode || "");
                    setUseEpay(result.data.UseEpay);
                }
                else {
                    setHouseCode("");
                    setUseEpay(false);
                }
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }
    };

    const getCoachSites = (value) => {
        if (value.id > 0) {
            setBackDrop(true);
            HttpService.post('/Geography/GetCoachSites', {
                siteName: value.name,
                siteId: value.id
            })
            .then((result) => {
                setCoachSites(result.data);
                setCurrentCoachSite([]);

                if (result.data.length > 0 && result.Current !== null) {
                    let items = result.data.filter(function (item) {
                        return item.Hirnode.toString() === result.Current.TeamCoachId;
                    })
                    if (items.length > 0) {
                        setCurrentCoachSite(items[0]);
                    }
                }
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }
    };

    const getHrcSites = (value) => {
        if (value.id > 0) {
            setBackDrop(true);
            HttpService.post('/Geography/GetHrcSites', {
                siteName: value.name,
                siteId: value.id
            })
            .then((result) => {
                setHrcSites(result.data);
                setCurrentHrcSite([]);

                if (result.data.length > 0 && result.Current !== null) {
                    let items = result.data.filter(function (item) {
                        return item.Hirnode.toString() === result.Current.TaskMGMTSystemId;
                    })
                    if (items.length > 0)
                        setCurrentHrcSite(items[0]);
                }
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }
    };

    const getMyDiningFacilitys = (value) => {
        if (value.id > 0) {
            setBackDrop(true);
            HttpService.post('/Geography/GetMyDiningFacilitys', {
                siteName: value.name,
                siteId: value.id
            })
            .then((result) => {
                if (result.data !== null) {
                    setMyDiningFacilitys(result.data);

                    if (result.data.length > 0 && result.Current !== null) {
                        let items = result.data.filter(function (item) {
                            return item.Id === result.Current.MyDiningId;
                        })
                        if (items.length > 0)
                            setCurrentMyDiningFacility(items[0]);
                        else
                            setCurrentMyDiningFacility([]);
                    }
                }
                else {
                    setMyDiningFacilitys([]);
                    setCurrentMyDiningFacility([]);
                }
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }
    };

    const saveSite = () => {
        setSiteOpen(false);
        setBackDrop(true);
        let id = (action === "Update" ? site.id : 0);

        HttpService.post('/Geography/SaveGeoLocation', {
            id: id,
            parentId: 0,
            name: siteName,
            startDate: goLiveDate,
            isActive: true
        })
        .then((result) => {
            const data = locations;
            const index = data.findIndex(item => item.id === id);
            if (index === -1)
                data.push(result);
            else {
                data[index].name = siteName;
                data[index].startDate = goLiveDate;
                data[index].isActive = true;
            }
            if (index !== -1)
                setActive(true);
            setLocations(data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const deactivateSite = () => {
        setDeactivateSiteOpen(false);
        setBackDrop(true);
        if (site.id > 0) {
            HttpService.post('/Geography/DeactivateGeoLocation', {
                id: site.id,
                name: siteName,
                endDate: endDate
            })
            .then((result) => {
                const data = locations;
                const index = data.findIndex(item => item.id === site.id);
                if (index !== -1) {
                    data[index].name = siteName;
                    data[index].endDate = endDate;
                    data[index].isActive = false;
                }
                setLocations(data);
                setActive(false);
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }
    };

    const saveData = (goBack) => {
        if (modified && site.id > 0) {
            setBackDrop(true);
            HttpService.post('/Geography/SaveHouseCode', {
                siteId: site.id,
                houseCode: houseCode.toString(),
                coachId: currentCoachSite.Hirnode === undefined ? null : currentCoachSite.Hirnode.toString(),
                hrcId: currentHrcSite.Hirnode === undefined ? null : currentHrcSite.Hirnode.toString(),
                myDiningId: currentMyDiningFacility.Id === undefined ? null : currentMyDiningFacility.Id.toString(),
                UseEpay: useEpay
            })
            .then((result) => {
                setModified(false);
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
        }

        if (goBack) {
            props.history.push("/");
        }
    };

    const importConfirm = () => {
        setTruncate(false);
        setConfirmMessage("New records will be added to this site and the old records won't be affected. Are you sure to continue?");
        setConfirmOpen(true);
    };

    const importTruncateConfirm = () => {
        setTruncate(true);
        setConfirmMessage("All locations under this site will be removed first. Are you sure to continue?");
        setConfirmOpen(true);
    };

    const importFromCSV = () => {
        setConfirmOpen(false);
        importFile.current.click();
    };

    const uploadFile = (event) => {
        setConfirmOpen(false);
        setBackDrop(true);

        let formdata = new FormData();
        formdata.append("file", event.target.files[0]);

        HttpService.postFile('/Geography/UploadFile', formdata)
        .then((result) => {
            if (result) {
                importFromCSVFile(result.name);
            }
            else {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
            }

            importFile.current.value = "";
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const importFromCSVFile = (fileName) => {
        HttpService.post('/Geography/ImportFromCSV', {
            siteId: site.id
            , fileName: fileName
            , truncate: truncate
        })
        .then((result) => {
            if (result.error) {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
                setBackDrop(false);
            }
            else {
                setErrorMessage("Geography imported successfully.");
                setSeverity('info');
                setAlertOpen(true);
                getLocations();
            }
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const exportToCSV = () => {
        setBackDrop(true);
        HttpService.post('/Geography/ExportToCSV', {
            siteId: site.id
        })
        .then((result) => {
            if (result.success) {
                let fileName = result.name;
                HttpService.downloadFile('/Report/DownloadFile', { fileName: fileName })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                    });
            }
            else {
                setErrorMessage(result.message);
                setSeverity('info');
                setAlertOpen(true);
            }
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    useEffect(() => {
        getLocations();
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="locationBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <div>
                        <Dialog fullWidth={true} maxWidth={"sm"} open={siteOpen} onClose={addSiteClose} TransitionComponent={Transition}>
                            <DialogContent>
                                <GridContainer style={{ justifyContent: 'center' }}>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card color="primary" style={{ background: currentTheme.background }}>
                                            <CardHeader style={{ background: currentTheme.palette.primary }} >
                                                <Typography variant="h6" className={classes.title}>{action} Site</Typography>
                                            </CardHeader>
                                            <CardBody style={{ color: currentTheme.text }}>
                                                <ValidatorForm autoComplete="off" style={{ width: "100%" }} onSubmit={saveSite}>
                                                    <div style={{ width: "100%", display: "block" }}>
                                                        <TextField
                                                            required
                                                            id="UpdateSiteName"
                                                            label="Site Name"
                                                            value={siteName}
                                                            onChange={e => setSiteName(e.target.value)}
                                                            variant="outlined"
                                                            style={{ width: "100%" }}
                                                        />
                                                        <br></br><br></br>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                disableToolbar
                                                                required
                                                                autoOk 
                                                                id="LiveDate"
                                                                label="Go Live Date"
                                                                format="MM/dd/yyyy"
                                                                value={goLiveDate}
                                                                onChange={date => setGoLiveDate(date)}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                margin="normal"
                                                                InputAdornmentProps={{ position: "start" }}
                                                                variant="inline"
                                                                inputVariant="outlined"
                                                                style={{ width: "100%" }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                    <div style={{ width: "100%", textAlign: "right", marginTop: "20px" }}>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            className={classes.button}
                                                            style={{ width: "100px" }}
                                                            startIcon={<CancelIcon />}
                                                            type="button"
                                                            onClick={addSiteClose}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        &nbsp; &nbsp;
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            className={classes.button}
                                                            style={{ background: currentTheme.secondary, width: "100px" }}
                                                            startIcon={<SaveIcon />}
                                                            type="submit"
                                                        >
                                                            Save
                                                    </Button>
                                                    </div>
                                                </ValidatorForm>
                                            </CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            </DialogContent>
                        </Dialog>
                        <Dialog fullWidth={true} maxWidth={"sm"} open={deactivateSiteOpen} onClose={deactivateSiteClose} TransitionComponent={Transition}>
                            <DialogContent>
                                <GridContainer style={{ justifyContent: 'center' }}>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card color="primary" style={{ background: currentTheme.background }}>
                                            <CardHeader style={{ background: currentTheme.palette.primary }} >
                                                <Typography variant="h6" className={classes.title}>Deactivate Site</Typography>
                                            </CardHeader>
                                            <CardBody style={{ color: currentTheme.text }}>
                                                <ValidatorForm autoComplete="off" style={{ width: "100%" }} onSubmit={deactivateSite}>
                                                    <div style={{ width: "100%", display: "block" }}>
                                                        <TextField
                                                            required
                                                            id="DeActivateSiteName"
                                                            label="Site Name"
                                                            value={siteName}
                                                            onChange={e => setSiteName(e.target.value)}
                                                            variant="outlined"
                                                            style={{ width: "100%" }}
                                                        />
                                                        <br></br><br></br>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                disableToolbar
                                                                required
                                                                autoOk 
                                                                id="EndDate"
                                                                label="End Date"
                                                                format="MM/dd/yyyy"
                                                                value={endDate}
                                                                onChange={date => setEndDate(date)}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                InputAdornmentProps={{ position: "start" }}
                                                                margin="normal"
                                                                variant="inline"
                                                                inputVariant="outlined"
                                                                style={{ width: "100%" }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </div>
                                                    <div style={{ width: "100%", textAlign: "right", marginTop: "10px" }}>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            className={classes.button}
                                                            style={{ width: "100px" }}
                                                            startIcon={<CancelIcon />}
                                                            type="button"
                                                            onClick={deactivateSiteClose}
                                                        >
                                                            Cancel
                                                    </Button>
                                                    &nbsp; &nbsp;
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            className={classes.button}
                                                            style={{ background: currentTheme.secondary, width: "100px" }}
                                                            startIcon={<SaveIcon />}
                                                            type="submit"
                                                        >
                                                            Save
                                                        </Button>
                                                    </div>
                                                </ValidatorForm>
                                            </CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            </DialogContent>
                        </Dialog>
                    </div>
                    <GridContainer style={{ justify: 'left' }}>
                        <GridItem xs={12} sm={12} md={12}>
                            <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                                <Toolbar>
                                    <IconButton edge="start" color="inherit" onClick={() => saveData(true)} aria-label="back">
                                        <KeyboardBackspaceIcon />
                                    </IconButton>
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item>
                                            <Typography variant="h6" className={classes.title}>Geography Settings</Typography>
                                        </Grid>
                                        <Grid item>
                                            <StatusIcon />
                                        </Grid>
                                    </Grid>
                                    <Grid container justify="flex-end">
                                        <SmallMenu modified={modified} saveCallback={() => saveData(false)} />
                                    </Grid>
                                </Toolbar>
                            </AppBar>
                            <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                                <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                    <ValidatorForm autoComplete="off" style={{ width: "100%" }} onSubmit={() => saveData(false)}>
                                        <div style={{ width: "100%", textAlign: "right" }}>
                                            {showResults && (
                                                <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary, width: "100px" }} startIcon={<SaveIcon />} type="submit">Save</Button>
                                            )} &nbsp;&nbsp;
                                            <Button variant="contained" color="primary" className={classes.button} style={{ background: currentTheme.secondary, width: "130px" }} startIcon={<AddIcon />} type="button" onClick={addSiteOpen}>Add Site</Button>
                                            &nbsp; &nbsp;
                                            {showResults ? <BindButtons /> : null}
                                        </div>
                                        <div style={{ width: "100%", marginTop: "15px" }}>
                                            <Autocomplete
                                                id="SiteName"
                                                value={site}
                                                options={locations}
                                                getOptionLabel={(option) => option.name || ""}
                                                onChange={(event, value) => bindData(value)}
                                                style={{ width: "100%", clear: "both" }}
                                                renderInput={(params) => <TextField {...params} label="Site Name" variant="outlined" />}
                                            />
                                        </div>
                                        <br></br>
                                        {showResults && (
                                            <div style={{ width: "100%" }}>
                                                <TextValidator fullWidth
                                                    id="HouseCode"
                                                    label="House Code"
                                                    placeholder="House Code"
                                                    value={houseCode}
                                                    onChange={(e) => {
                                                        setHouseCode(e.target.value);
                                                        setModified(true);
                                                    }}
                                                    variant="outlined"
                                                    style={{ width: "100%" }}
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                />
                                                <br></br><br></br>
                                                <Autocomplete
                                                    id="CoachSite"
                                                    value={currentCoachSite}
                                                    options={coachSites}
                                                    getOptionLabel={(option) => option.Title || ""}
                                                    onChange={(event, value) => {
                                                        setCurrentCoachSite(value);
                                                        setModified(true);
                                                    }}
                                                    style={{ width: "100%" }}
                                                    renderInput={(params) => <TextField {...params} label="TeamCoach Site" variant="outlined" />}
                                                />
                                                <br></br>
                                                <Autocomplete
                                                    id="HrcSite"
                                                    value={currentHrcSite}
                                                    options={hrcSites}
                                                    getOptionLabel={(option) => option.Title || ""}
                                                    onChange={(event, value) => {
                                                        setCurrentHrcSite(value);
                                                        setModified(true);
                                                    }}
                                                    style={{ width: "100%" }}
                                                    renderInput={(params) => <TextField {...params} label="HRC Site" variant="outlined" />}
                                                />
                                                <br></br>
                                                <Autocomplete
                                                    id="MyDiningFacility"
                                                    value={currentMyDiningFacility}
                                                    options={myDiningFacilitys}
                                                    getOptionLabel={(option) => option.Title || ""}
                                                    onChange={(event, value) => {
                                                        setCurrentMyDiningFacility(value);
                                                        setModified(true);
                                                    }}
                                                    style={{ width: "100%" }}
                                                    renderInput={(params) => <TextField {...params} label="MyDining Facility" variant="outlined" />}
                                                />
                                                <br></br>
                                                <FormControlLabel
                                                    value="UseEpay"
                                                    control={<Checkbox color="primary" />}
                                                    label="Use Epay"
                                                    labelPlacement="end"
                                                    checked={useEpay}
                                                    onChange={(e) => {
                                                        setUseEpay(e.target.checked);
                                                        setModified(true);
                                                    }}
                                                />
                                                <FormControlLabel
                                                    value="Active"
                                                    control={<Checkbox color="primary" />}
                                                    label="Active"
                                                    labelPlacement="end"
                                                    checked={active}
                                                    onChange={e => changeStatus(e.target.checked)}
                                                />
                                            </div>
                                        )}
                                    </ValidatorForm>
                                    <input type='file' ref={importFile} style={{ display: 'none' }} onChange={uploadFile} />
                                    <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={importFromCSV} title="Import" message={confirmMessage} />
                                    <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
